import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Unsubscribed: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [errorType, setErrorType] = useState<string>("");

  useEffect(() => {
    const success = searchParams.get("success");
    const error = searchParams.get("error");

    if (success === "true") {
      setStatus("success");
    } else if (error) {
      setStatus("error");
      setErrorType(error);
    } else {
      setStatus("error");
      setErrorType("unknown");
    }
  }, [searchParams]);

  const getErrorMessage = (errorType: string) => {
    switch (errorType) {
      case "invalid-token":
        return "Link wypisywania się jest nieprawidłowy. Sprawdź czy skopiowałeś cały link z emaila.";
      case "token-expired":
        return "Link wypisywania się wygasł lub został już użyty. Możesz zmienić ustawienia powiadomień w panelu konta.";
      default:
        return "Wystąpił nieoczekiwany błąd podczas wypisywania się z powiadomień.";
    }
  };

  const renderContent = () => {
    switch (status) {
      case "success":
        return (
          <div className="max-w-md mx-auto bg-white rounded-lg shadow-sm border border-neutral-200 p-8 text-center">
            <div className="w-16 h-16 bg-success-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg
                className="w-8 h-8 text-success-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-neutral-900 mb-4">
              Pomyślnie wypisano z powiadomień
            </h1>

            <p className="text-neutral-600 mb-8">
              Nie będziesz już otrzymywać powiadomień email o nowych dotacjach z
              KFS i BUR.
            </p>

            <div className="space-y-4">
              <a
                href="/account/settings"
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                Zmień ustawienia powiadomień
              </a>

              <a
                href="/"
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-neutral-300 text-sm font-medium rounded-md text-neutral-700 bg-white hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                Przejdź do strony głównej
              </a>
            </div>
          </div>
        );

      case "error":
        return (
          <div className="max-w-md mx-auto bg-white rounded-lg shadow-sm border border-neutral-200 p-8 text-center">
            <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg
                className="w-8 h-8 text-error-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-neutral-900 mb-4">
              Wystąpił problem
            </h1>

            <p className="text-neutral-600 mb-8">
              {getErrorMessage(errorType)}
            </p>

            <div className="space-y-4">
              <a
                href="/account/settings"
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                Przejdź do ustawień powiadomień
              </a>

              <a
                href="/"
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-neutral-300 text-sm font-medium rounded-md text-neutral-700 bg-white hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                Przejdź do strony głównej
              </a>
            </div>
          </div>
        );

      default:
        return (
          <div className="max-w-md mx-auto bg-white rounded-lg shadow-sm border border-neutral-200 p-8 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-6"></div>
            <h1 className="text-xl font-medium text-neutral-900">
              Przetwarzanie...
            </h1>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      {renderContent()}
    </div>
  );
};

export default Unsubscribed;
